import {Tabs} from "antd";
import styles from "./index.less";
import UserVipSet from "./UserVipSet";
import DeveloperVipSet from "./DeveloperVipSet";

export default function (props) {
  return <Tabs
    className={styles.fullPage}
    centered={true}
    items={[
      {
        key: 'userVipSet',
        label: '用户会员',
        children: (
          <div className={styles.tabPaneBox}>
            <UserVipSet
              {...props}
            />
          </div>
        ),
      },
      {
        key: 'DeveloperVipSet',
        label: '开发者会员',
        children: (
          <div className={styles.tabPaneBox}>
            <DeveloperVipSet
              {...props}
            />
          </div>
        ),
      }
    ]}
  />
}